import he1 from '../assets/images/gallery/he1.png';
import he2 from '../assets/images/gallery/he2.png';
import he3 from '../assets/images/gallery/he3.png';
import he4 from '../assets/images/gallery/he4.png';
import he5 from '../assets/images/gallery/he5.png';
import he6 from '../assets/images/gallery/he6.jpg';
import he7 from '../assets/images/gallery/he7.jpg';
import he8 from '../assets/images/gallery/he8.jpg';
import us1 from '../assets/images/gallery/us1.jpg';
import us2 from '../assets/images/gallery/us2.jpg';
import us3 from '../assets/images/gallery/us3.jpg';
import us4 from '../assets/images/gallery/us4.jpg';



const galleryData = [
    {
        id: 1,
        image: he1,
        caption: 'Handsome, calm, and completely mine. 😌❤️',
        corner: 'top-left',
    },
    {
        id: 2,
        image: he2,
        caption: 'Soft moments, forever memories. 💕📷',
        corner: 'bottom-right',
    },
    {
        id: 3,
        image: he3,
        caption: 'Smiles I never want to forget 🥹',
        corner: 'top-right',
    },
    {
        id: 4,
        image: us1,
        caption: 'With you, everything felt right 💖',
        corner: 'bottom-left',
    },
    {
        id: 5,
        image: he4,
        caption: 'you being dramtic is everything 🥹💕',
        corner: 'top-left',
    },
    {
        id: 6,
        image: he5,
        caption: 'Slaying like this always 💗',
        corner: 'bottom-right',
    },
    {
        id: 7,
        image: us2,
        caption: 'Where I belong… right here. 🫂✨',
        corner: 'top-right',
    },
    {
        id: 8,
        image: he6,
        caption: 'This smiles of Yours and my heart melts instantly 🥹💗',
        corner: 'bottom-left',
    },
    {
        id: 9,
        image: us3,
        caption: 'Some moments to remember and smile 🥹💖💗',
        corner: 'top-left',
    },
    {
        id: 10,
        image: us4,
        caption: 'I love spending cozy moments with you like this  🥹',
        corner: 'bottom-right',
    },
    {
        id: 11,
        image: he7,
        caption: 'Hotty and always serving classy looks 😘💗🧿💕💝',
        corner: 'top-right',
    },
    {
        id: 12,
        image: he8,
        caption: 'looks like You are Smiling while having chat with me 🥹🫣🤪😜',
        corner: 'bottom-left',
    },
];

export default galleryData;
